/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Growth_Title_AccentInputs */

const en_about_growth_title_accent = /** @type {(inputs: About_Growth_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`the whole community`)
};

const es_about_growth_title_accent = /** @type {(inputs: About_Growth_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`toda la comunidad`)
};

const de_about_growth_title_accent = /** @type {(inputs: About_Growth_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`für die ganze Gemeinschaft`)
};

const zh_about_growth_title_accent = /** @type {(inputs: About_Growth_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`训练场`)
};

const ar_about_growth_title_accent = /** @type {(inputs: About_Growth_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المجتمع بأكمله`)
};

const fr_about_growth_title_accent = /** @type {(inputs: About_Growth_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`toute la communauté`)
};

const vi_about_growth_title_accent = /** @type {(inputs: About_Growth_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`cả cộng đồng`)
};

const sw_about_growth_title_accent = /** @type {(inputs: About_Growth_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`jamii nzima`)
};

const th_about_growth_title_accent = /** @type {(inputs: About_Growth_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ชุมชนทั้งหมด`)
};

const bs_about_growth_title_accent = /** @type {(inputs: About_Growth_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`cijelu zajednicu`)
};

const ja_about_growth_title_accent = /** @type {(inputs: About_Growth_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`施設`)
};

const ko_about_growth_title_accent = /** @type {(inputs: About_Growth_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`지은 시설`)
};

const pt_about_growth_title_accent = /** @type {(inputs: About_Growth_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`toda a comunidade`)
};

const it_about_growth_title_accent = /** @type {(inputs: About_Growth_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`tutta la comunità`)
};

const sv_about_growth_title_accent = /** @type {(inputs: About_Growth_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hela gemenskapen`)
};

const nl_about_growth_title_accent = /** @type {(inputs: About_Growth_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`de hele gemeenschap`)
};

const da_about_growth_title_accent = /** @type {(inputs: About_Growth_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hele samfundet`)
};

const nb_about_growth_title_accent = /** @type {(inputs: About_Growth_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hele samfunnet`)
};

const fi_about_growth_title_accent = /** @type {(inputs: About_Growth_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`koko yhteisölle`)
};

const pl_about_growth_title_accent = /** @type {(inputs: About_Growth_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`cała społeczność`)
};

const ru_about_growth_title_accent = /** @type {(inputs: About_Growth_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`всего сообщества`)
};

const tr_about_growth_title_accent = /** @type {(inputs: About_Growth_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`kurulmuş bir tesis`)
};

const hi_about_growth_title_accent = /** @type {(inputs: About_Growth_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`एक सुविधा`)
};

const id_about_growth_title_accent = /** @type {(inputs: About_Growth_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`seluruh komunitas`)
};

const ms_about_growth_title_accent = /** @type {(inputs: About_Growth_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`seluruh komuniti`)
};

const cs_about_growth_title_accent = /** @type {(inputs: About_Growth_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`celé společenství`)
};

const el_about_growth_title_accent = /** @type {(inputs: About_Growth_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`όλη η κοινότητα`)
};

const he_about_growth_title_accent = /** @type {(inputs: About_Growth_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`כל הקהילה`)
};

const af_about_growth_title_accent = /** @type {(inputs: About_Growth_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`die hele gemeenskap`)
};

const hu_about_growth_title_accent = /** @type {(inputs: About_Growth_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`az egész közösségnek`)
};

/**
* | output |
* | --- |
* | "the whole community" |
*
* @param {About_Growth_Title_AccentInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const about_growth_title_accent = /** @type {((inputs?: About_Growth_Title_AccentInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Growth_Title_AccentInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_about_growth_title_accent(inputs)
	if (locale === "de") return de_about_growth_title_accent(inputs)
	if (locale === "zh") return zh_about_growth_title_accent(inputs)
	if (locale === "ar") return ar_about_growth_title_accent(inputs)
	if (locale === "fr") return fr_about_growth_title_accent(inputs)
	if (locale === "vi") return vi_about_growth_title_accent(inputs)
	if (locale === "sw") return sw_about_growth_title_accent(inputs)
	if (locale === "th") return th_about_growth_title_accent(inputs)
	if (locale === "bs") return bs_about_growth_title_accent(inputs)
	if (locale === "ja") return ja_about_growth_title_accent(inputs)
	if (locale === "ko") return ko_about_growth_title_accent(inputs)
	if (locale === "pt") return pt_about_growth_title_accent(inputs)
	if (locale === "it") return it_about_growth_title_accent(inputs)
	if (locale === "sv") return sv_about_growth_title_accent(inputs)
	if (locale === "nl") return nl_about_growth_title_accent(inputs)
	if (locale === "da") return da_about_growth_title_accent(inputs)
	if (locale === "nb") return nb_about_growth_title_accent(inputs)
	if (locale === "fi") return fi_about_growth_title_accent(inputs)
	if (locale === "pl") return pl_about_growth_title_accent(inputs)
	if (locale === "ru") return ru_about_growth_title_accent(inputs)
	if (locale === "tr") return tr_about_growth_title_accent(inputs)
	if (locale === "hi") return hi_about_growth_title_accent(inputs)
	if (locale === "id") return id_about_growth_title_accent(inputs)
	if (locale === "ms") return ms_about_growth_title_accent(inputs)
	if (locale === "cs") return cs_about_growth_title_accent(inputs)
	if (locale === "el") return el_about_growth_title_accent(inputs)
	if (locale === "he") return he_about_growth_title_accent(inputs)
	if (locale === "af") return af_about_growth_title_accent(inputs)
	if (locale === "hu") return hu_about_growth_title_accent(inputs)
	return en_about_growth_title_accent(inputs)
});